import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddAssignee from './addassignee/index'
import AssigneeList from './assigneelist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddAssigneeProtected_ma = userIsCommitteeAdminRedir(AddAssignee)
const AssigneeListProtected_ma = userIsCommitteeAdminRedir(AssigneeList)

const Assignee = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Assignee Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/assignee-list`} />
            <Route path={`${match.url}/add-assignee/:id?`} component={AddAssigneeProtected_ma} />
            <Route path={`${match.url}/assignee-list/:id?`} component={AssigneeListProtected_ma} />
        </Switch>
    </div>
);

export default Assignee;



// WEBPACK FOOTER //
// ./app/assigneedetails/index.js